import { DEFAULT_DESIGN_SYSTEM_THEME, DesignSystemTheme } from '../constants';

export const designSystem: DesignSystemTheme = { ...DEFAULT_DESIGN_SYSTEM_THEME };
